export function formatDemoInstructorLabel(person) {
  if (!person) return '';
  const first = person.first_name || person.firstName || '';
  const last = person.last_name || person.lastName || '';
  const name = `${first} ${last}`.trim();
  const role = String(person.role || person.teacher_role || '');
  if (role === 'sales') return name ? `${name} (Sales)` : 'Sales';
  if (role === 'sales_supervisor') return name ? `${name} (Sales Supervisor)` : 'Sales Supervisor';
  if (role === 'country_manager') return name ? `${name} (Country Manager)` : 'Country Manager';
  return name;
}
